import { IconMovie, IconPhoto, IconStack2, IconRectangleVertical } from '@tabler/icons-react';
import { isArtFormat } from '../features/ArtEditor/headless';

// Ids follow the platform-wide `<platform>::<format>` notation (contract 1.2.0 StudioContentFormat).
// i18next reads `:` as a namespace separator, so labels come from `labelKey`, never from the id.
// An art format (`art: true`) is offered once the core lists it in `capabilities.formats`
// (contract 2.7.0 proposal); its `ratios` are the aspect ratios the composer offers.
export const STUDIO_FORMATS = [
  { id: 'instagram::reels', platform: 'instagram', labelKey: 'reels', icon: IconMovie, available: true, ratio: '9:16' },
  { id: 'instagram::stories', platform: 'instagram', labelKey: 'stories', icon: IconRectangleVertical, available: false },
  { id: 'instagram::carousel', platform: 'instagram', labelKey: 'carousel', icon: IconStack2, available: false, art: true, ratio: '4:5', ratios: ['4:5', '1:1', '3:4'] },
  { id: 'instagram::post', platform: 'instagram', labelKey: 'post', icon: IconPhoto, available: false, art: true, ratio: '4:5', ratios: ['4:5', '1:1', '3:4'] },
];

export const DEFAULT_FORMAT = 'instagram::reels';
export const ART_DEFAULT_RATIO = '4:5';

export const formatLabelKey = id => STUDIO_FORMATS.find(format => format.id === id)?.labelKey || 'reels';
export const formatAvailable = (format, capabilities) => !!format && (format.available || (!!format.art && !!capabilities?.formats?.includes(format.id)));
export const isArtProject = project => isArtFormat(project?.brief?.format);
export { isArtFormat };
